import { useTranslation } from "@ncp/i18n";
import { MOD, ShortcutsDialog as Dialog } from "@ncp/ui";

export { MOD };

export function ShortcutsDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  const { t } = useTranslation();
  const rows = [
    { keys: [MOD, "K"], label: t("admin:shell.shortcutList.palette") },
    { keys: ["/"], label: t("admin:shell.shortcutList.search") },
    { keys: ["g", "o"], label: t("admin:shell.shortcutList.overview") },
    { keys: ["g", "h"], label: t("admin:shell.shortcutList.workspaces") },
    { keys: ["g", "l"], label: t("admin:shell.shortcutList.solutions") },
    { keys: ["g", "w"], label: t("admin:shell.shortcutList.workflows") },
    { keys: ["g", "r"], label: t("admin:shell.shortcutList.releases") },
    { keys: [MOD, "S"], label: t("admin:shell.shortcutList.save") },
    { keys: ["?"], label: t("admin:shell.shortcutList.help") },
  ];
  return <Dialog open={open} onOpenChange={onOpenChange} title={t("admin:shell.shortcuts")} description={t("admin:shell.helpHint")} rows={rows} />;
}
